export namespace System {
  export namespace OrderFlow {
    export const inboundId = '00000000-0000-0000-0000-000000000001';
    export const moveId = '00000000-0000-0000-0000-000000000002';
    export const outboundId = '00000000-0000-0000-0000-000000000003';
  }

  export namespace OrderStatus {
    export const createdId = '00000000-0000-0000-0000-000000000001';
    export const inProgressId = '00000000-0000-0000-0000-000000000002';
    export const completedId = '00000000-0000-0000-0000-000000000003';

    export const cancelledId = '00000000-0000-0000-0000-000000000004';

    export const pickingInProgressId = '00000000-0000-0000-0000-000000000005';
    export const readyForPickupId = '00000000-0000-0000-0000-000000000006';
    export const pickupInProgressId = '00000000-0000-0000-0000-000000000007';
  }

  export namespace ProductTransactionStatus {
    export const createdId = '00000000-0000-0000-0000-000000000001';
    export const completedId = '00000000-0000-0000-0000-000000000002';
    export const pickedId = '00000000-0000-0000-0000-000000000003';

    export const cancelledId = '00000000-0000-0000-0000-000000000004';
    export const rollbackId = '00000000-0000-0000-0000-000000000005';
  }

  export namespace ProductStatus {
    export const decreaseId = '10000000-0000-0000-0000-000000000000';
    export const increaseId = '20000000-0000-0000-0000-000000000000';

    export const availableId = '00000000-0000-0000-0000-000000000001';
  }
}
